<template>
    <div>
    <div v-if="online">
      <div class="logo"></div>
      <el-form ref="signin"
              :model="signin"
              :rules="rules"
              label-position="top"
              @keyup.enter.native="submitLogin">
          <el-form-item label="Email" prop="login" >
              <el-input v-model="signin.login" name="email" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="Пароль" prop="password">
              <el-input v-model="signin.password" name="password" show-password auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" :loading="load" @click="submitLogin">Войти</el-button>
          </el-form-item>
      </el-form>
    </div>
    <h1 v-else class="no-connection">Проверьте интернет соединение</h1>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'Login',
  data () {
    return {
      load: !!0,
      signin: {
        login: null,
        password: null
      },
      rules: {
        login: [
          { required: true, message: 'Ошибка e-mail', trigger: 'blur' },
          { type: 'email', message: 'Ошибка', trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: 'Ошибка пароля', trigger: 'blur' }
        ]
      },
      error: null,
      online: window.navigator.onLine
    }
  },
  created () {
    document.title = 'Авторизация'
  },
  computed: {
  },
  mounted () {
    window.addEventListener('online', () => this.onStatus(!!1))
    window.addEventListener('offline', () => this.onStatus(!!0))
  },
  methods: {
    ...mapActions({
      login: 'auth/LOGIN'
    }),
    onStatus (t) {
      this.online = t
    },
    submitLogin () {
      this.error = null
      this.$refs.signin.validate((valid) => {
        if (valid) {
          this.load = !!1

          this.login(this.signin).then(() => {
            this.$notify.success({
              title: 'Удачно...',
              message: 'Успешная авторизация'
            })

            this.$router.push('/')
          }).catch((response) => {
            this.$notify.error({
              title: 'Ошибка авторизации',
              message: response.response.data.message
            })
          }).finally(() => {
            this.load = !!0
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .logo {
    margin: 0 auto 10px auto;
    display: block;
    max-width: 194px;
    height: 158px;

    background-color: #64F0BF;
    -webkit-mask: url('../../assets/logo.svg') no-repeat center/cover;
    mask: url('../../assets/logo.svg') no-repeat center/cover;

  }
  .no-connection {
    text-align: center;
  }
</style>
